module.exports = __webpack_public_path__ + "static/NAIC-b911db005041fb7bd85ca794afedf04e.png";